// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__qLK8T","checkboxCol":"Table_checkboxCol__1ez5Q","emailCol":"Table_emailCol__1FSmg","actionCol":"Table_actionCol__25JN_"};